export default __webpack_public_path__ + "static/media/Events.9361b221.svg";